export const formValidatorTypes = {
    cleanFormValidator: "[FormValidator] clean",
    setErrors: "[FormValidator] setting Errors",
    removeError: "[FormValidator] removing Errors",
};
